'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'slick-carousel';

// ----------------------------------------
// Private
// ----------------------------------------

let $mainSlider = $('.main-slider');
let $offerSlider = $('.offers-slider');
let $similarSlider = $('.similar-slider');
let $photoSlider = $('.photo-slider');
let $photoNavSlider = $('.photo-nav-slider');
let $offerControls = $('.offers-slider__control');
let $similarControls = $('.similar-slider__control');
let $video = $('video');

// ----------------------------------------
// Public
// ----------------------------------------

function mainSlider () {



	let mailSlider = $mainSlider.slick($.extend({},true, {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		autoplay:true,
		prevArrow: `<button type='button' class='slick-arrow slick-prev'></button>`,
		nextArrow: `<button type='button' class='slick-arrow slick-next'></button>`
	},$mainSlider.data('param')));

	let autoplayStatus = false;


	if ($mainSlider.length && $mainSlider.data('param').autoplay){
		autoplayStatus = true;
	}

		$mainSlider
		.on('afterChange', function(event, slick, currentSlide){
			videoOllPause();
			// let $video = $(slick.$slider[0]).find('video');
			// console.log(slick);
			// console.log($(slick.$slider[0]));

			let $slide = $('.js-mainSlider .slick-active'),
				$video = $slide.find('video');
			if($video.length){
				$mainSlider.slick('slickSetOption', 'autoplay', false, true);
				$video[0].play();
			} else {

				if (autoplayStatus){
					$mainSlider.slick('slickSetOption', 'autoplay', true, true);
				}

			}

			// if($(slick.$slider[0]).find('video').length){
			// 	$(slick.$slider).find('video').play();
			// } else {
			// 	$mainSlider.slickSetOption("autoplay",false,false);
			// }
		});


		let $slide = $('.js-mainSlider .slick-active'),
			$video = $slide.find('video');
		if($video.length){
			$video[0].play();
		}


		let $videoList = $mainSlider.find('video');

		$videoList.each(function (i,el) {
			el.addEventListener('ended', function () {
				videoOllPause();
				// $mainSlider.slickSetOption("autoplay",true,false);
				if (autoplayStatus){
					$mainSlider.slick('slickSetOption', 'autoplay', true, true);
					$mainSlider.slick('slickNext');
				} else {
					let $slide = $('.js-mainSlider .slick-active'),
						$video = $slide.find('video');
					if($video.length){
						$video[0].currentTime = 0;
						$video[0].play();
					}
				}

			}, false);


			$(el).on("startVideo", function () {
				console.log('start');
				el.paly();

			});
		});

		function videoOllPause(){
			$videoList.each(function(i,el){
				el.pause();
				el.currentTime = 0
			});
		}





}

function offerSlider () {
	$offerSlider.slick($.extend({},true,{
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		infinite: true,
		dots: true,
		appendDots: $offerControls,
		touchThreshold: 12,
		appendArrows: $('.offers-block'),
		centerPadding: '0',
		autoplay:true,
		prevArrow: `<button type='button' class='slick-arrow slick-prev'><span class="slick-arrow-icon slick-prev-icon"></span></button>`,
		nextArrow: `<button type='button' class='slick-arrow slick-next'><span class="slick-arrow-icon slick-next-icon"></span></button>`,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 1
				}
			}
		]
	}, $offerSlider.data('param')));



}

function similarSlider () {
	$similarSlider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		dots: true,
		autoplay:true,
		appendDots: $similarControls,
		prevArrow: `<button type='button' class='slick-arrow slick-prev'></button>`,
		nextArrow: `<button type='button' class='slick-arrow slick-next'></button>`,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2
				}
			}, {
				breakpoint: 641,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}

function photoSlider () {
	$photoSlider.slick({
		slidesToShow: 1,
		infinite: true,
		fade: true,
		dots: false,
		autoplay:false,
		accessibility: false,
		asNavFor: $photoNavSlider,
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>'
	});

	$photoNavSlider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: $photoSlider,
		focusOnSelect: true,
		vertical: true,
		infinite: true,
		arrows: true,
		autoplay:false,
		prevArrow: '<button type="button" class="slick-arrow trumb__prev slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow trumb__next slick-next"></button>',
		responsive: [
			{
				breakpoint: 1440,
				settings: {
					slidesToShow: 4
				}
			}, {
				breakpoint: 1280,
				settings: {
					vertical: false
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 4,
					vertical: false
				}
			}, {
				breakpoint: 640,
				settings: {
					slidesToShow: 3,
					vertical: false
				}
			}
		]
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {mainSlider, offerSlider, similarSlider, photoSlider};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/sliders.js